import { initialPagination, initialState, makeListReducers } from '@/models/utils';
import { bindServices } from '@/services/api';
import CoreQueries from '@/utils/input/queries';

import { DEFAULT_ORDER_BY, FETCH_ROUTE, MODEL_NAME } from './constants';
import { filtersConfig } from './utils';

const api = bindServices(MODEL_NAME);
const pagedQuery = CoreQueries.Trace.paged;

/** Pattern B — hand-rolled read-only model adapted to ConfigListPage contract (`fetchList` / `showForm`). */
const moduleInitialState = {
  ...initialState,
  list: [],
  orderBy: DEFAULT_ORDER_BY,
  select: pagedQuery.select,
  searchSelect: pagedQuery.searchSelect,
  showForm: false,
  detail: false,
  id: null,
  item: null,
  success: false,
  activatingItemIds: {},
  filtersConfig,
};

const TraceModel = {
  namespace: MODEL_NAME,
  state: moduleInitialState,
  effects: {
    *fetchList({ payload }, { call, put, select }) {
      try {
        const pagination = yield select((state) => state[MODEL_NAME].pagination);
        const pageSize = yield select((state) => state.global.pageSize);
        const res = yield call(api.getAll, {
          route: payload.route ? payload.route : `${FETCH_ROUTE}/paged`,
          params: {
            limit: pageSize,
            ...pagedQuery,
            ...pagination,
            ...payload,
          },
          readPriority: true,
        });

        yield put({
          type: 'queryData',
          payload: { ...res, limit: pageSize, page: payload.page },
        });
      } catch (e) {
        /*  */
      }
    },

    *fetchItem({ payload }, { call, put }) {
      try {
        yield put({ type: 'success', payload: false });
        const res = yield call(api.getById, {
          route: FETCH_ROUTE,
          id: payload.id,
          params: {
            ...(payload.detail ? CoreQueries.Trace.itemDetail : {}),
            ...(payload?.params && { ...payload.params }),
          },
        });
        yield put({ type: 'queryItem', payload: res });
      } catch (e) {
        /*  */
      }
    },

    *setOrderBy({ payload }, { put }) {
      yield put({
        type: 'queryOrderBy',
        payload,
      });
    },

    *showForm({ payload }, { put }) {
      yield put({
        type: 'queryShowForm',
        payload,
      });
    },

    *resetState(_, { put }) {
      yield put({ type: 'reset' });
    },
  },
  reducers: {
    ...makeListReducers({
      initialPagination,
      initialState: moduleInitialState,
    }),
    setFiltersConfig(state, { payload }) {
      return {
        ...state,
        filtersConfig: payload,
      };
    },
  },
};

export default TraceModel;
